(async () => {
  const baseComponent = await import(window.theme.modules.baseComponent);

  customElements.define('product-recommendations', class extends baseComponent.default {

    render() {
      fetch(this.dataset.url)
        .then(response => response.text())
        .then(text => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('product-recommendations');
          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
            this._initCarousel();
          }
        })
        .catch(e => {
          console.error(e);
        });
    };

    _initCarousel() {
      const carousel = this.querySelector('[data-pr-carousel]');
      if (!carousel) return;

      const track = carousel.querySelector('[data-pr-track]');
      const prevBtn = carousel.querySelector('[data-pr-prev]');
      const nextBtn = carousel.querySelector('[data-pr-next]');
      const fill = carousel.querySelector('[data-pr-progress]');
      if (!track) return;

      const step = () => {
        const slide = track.querySelector('.pr-carousel__slide');
        const gap = parseInt(getComputedStyle(track).columnGap || 24, 10);
        return slide ? slide.offsetWidth + gap : 300;
      };

      const update = () => {
        const max = track.scrollWidth - track.clientWidth;

        if (fill) {
          const thumbWidth = Math.min(100, (track.clientWidth / track.scrollWidth) * 100);
          const thumbLeft = max <= 0 ? 0 : (track.scrollLeft / max) * (100 - thumbWidth);
          fill.style.width = thumbWidth + '%';
          fill.style.left = thumbLeft + '%';
        }

        if (prevBtn) prevBtn.disabled = track.scrollLeft <= 4;
        if (nextBtn) nextBtn.disabled = track.scrollLeft >= max - 4;
      };

      if (prevBtn) {
        prevBtn.addEventListener('click', () => {
          track.scrollBy({ left: -step() * 2, behavior: 'smooth' });
        });
      }

      if (nextBtn) {
        nextBtn.addEventListener('click', () => {
          track.scrollBy({ left: step() * 2, behavior: 'smooth' });
        });
      }

      track.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update();
    }
  });
})();
